import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import {
  StyledResultTableSavings,
} from '../shared/resultsStyles';
import { palette, breakpoints } from '../../constants/styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import Modal from '../shared/Modal';
import ResultSubsection from '../shared/ResultSubsection';
import StatusCard from './StatusCard';

const StyledBulletContainer = styled.div`
  height: 20px;
  margin-top: 0.5rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledBullet = styled.div`
  height: 10px;
  width: 10px;
  margin: 0px;
  margin-top: 5px;
  margin-right: 10px;
  ${({ color }) => color && css`
    background-color: ${color};
  `}
`;

const StyledOptionsContainer = styled.div`
  width: 100%;
`;

const StyledOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledInterestEarned = styled.div`
  display: flex;
  flex-direction: row;
  width: 70%;
  ${breakpoints.mobileLandscape} {
    width: 80%;
  }
`;

const StyledInterestEarnedNumber = styled.div`
  width: 30%;
  text-align: left;
  margin-left: 15px;

  ${breakpoints.mobileLandscape} {
    width: 20%;
  }
`;

const StyledResultStatementContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0.5rem 0 1.5rem 0;
`;

const Border = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #cecece;
  margin: 10px 0px;
`;

const percColors = ['#8c8c8c', '#3399dd', '#393920'];


const StatusTable = ({ entries, section }) => {
  console.log(entries);
  return (
    <Fragment>
      {
        entries.map((entry, i) => (
          <Fragment>
            <div key={`${section}-${i}-${entry.text}`} style={{ width: '100%' }}>
              <StatusCard
                color={entry.color}
                icon={entry.icon}
                label={entry.label}
                text={entry.text}
              />
            </div>
            <Fragment>
              {
                i !== entries.length - 1
                && (
                  <Border />
                )
              }
            </Fragment>
          </Fragment>
        ))
      }
    </Fragment>
  );
};

export default StatusTable;
